import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import clsx from 'clsx'

import { FileCategory } from '@makyoapp/makyo-sdk/models/Files'
import { AttachFile16 } from '@makyoapp/makyo-icon/icon'

import { getFileTypeFromId } from '@/shared/utils'

import { FileManager } from '../FileManager/FileManager'
import { VariableWrapper } from './VariableWrapper'

export default function VariableFile({
  id,
  onChange,
  onHide,
}: {
  id?: string
  onChange: (value: string) => void
  onHide: () => void
}) {
  const [show, setShow] = useBoolean(false)

  const fileTypes: FileCategory[] = getFileTypeFromId(id)

  return (
    <VariableWrapper
      title={<Trans>File</Trans>}
      icon={<AttachFile16 />}
      show={show}
      defaultHeight={false}
      defaultWidth={false}
      setShow={setShow}
      placement='auto'
      defaultMenuPad={false}
      menuClassName={clsx('w-[500px] min-h-[170px]')}
    >
      <FileManager
        fileTypes={fileTypes}
        id={id}
        modal={false}
        gridCols={3}
        maxHeight='20vh'
        forceUrlPanelHeight
        onChange={(ty, v) => {
          onChange(`${v}`)
        }}
        onHide={() => {
          setShow(false)
          onHide()
        }}
      />
    </VariableWrapper>
  )
}
